import React from 'react';
import Grid from 'styled-components-grid';
import ThxBox from "../index";
import {StyledCard} from "../../../styleHelper";
import {Card} from "../../../styledComponents";

const ReservationInformation = ({customerInformation}) => {
    const {bookingManager, companyInformation, date} = customerInformation;

    return (
        <Card
            title="Bokningsuppgifter">
            <Grid>
                <Grid.Unit size={1 / 2}>
                    <h4>Bokningsansvarig</h4>
                    <dl>
                        {Object.keys(bookingManager).map((key) => (
                            <React.Fragment>
                                <dt>{key.charAt(0).toUpperCase() + key.slice(1)}</dt>
                                <dd>{bookingManager[key]}</dd>
                            </React.Fragment>
                        ))}
                    </dl>
                </Grid.Unit>
                {companyInformation && (
                    <Grid.Unit size={1 / 2}>

                        <h4>Företagsuppgifter</h4>
                        <dl>
                            {Object.keys(companyInformation).map((key) => (
                                <React.Fragment>
                                    <dt>{key.charAt(0).toUpperCase() + key.slice(1)}</dt>
                                    <dd>{companyInformation[key]}</dd>
                                </React.Fragment>
                            ))}
                        </dl>
                    </Grid.Unit>
                )}

            </Grid>
        </Card>
    )

};

export default ReservationInformation;



// WEBPACK FOOTER //
// ./src/components/Confirmation/components/ReservationInformation.jsx